import css from './aio.less';
import {forwardRef} from "react";
import cn from 'classnames';
import {useUuid} from "../../helpers/react-hooks";
import AioIcon from "./AioIcon";
import type {ClassValue} from '../../helpers/react-helpers'
import AioLabel from './AioLabel'
import icons from '../../../markons/markons'
import {useTestId} from '../../contexts/testid'

export interface AioTextProps extends Pick<React.ComponentPropsWithoutRef<'input'>, 'value' | 'onChange' | 'disabled' | 'onFocus' | 'onBlur' | 'defaultValue' | 'children' | 'type' | 'inputMode' | 'min' | 'max' | 'step' | 'placeholder' | 'onClick' | 'readOnly' | 'autoComplete' | 'autoFocus'> {
    width?: number | string
    minWidth?: number | string
    maxWidth?: number | string
    icon?: string
    label: string
    inputClass?: string
    labelClass?: string
    className?: ClassValue
    id?: string
    loading?: boolean
    // size?: number
    inline?: boolean
    required?: boolean
    testId?: string
    error?: boolean
}

const AioText = forwardRef(({id, width, minWidth, maxWidth, icon, label, inputClass, error, disabled, labelClass, required, className, loading, inline, testId, ...inputProps}: AioTextProps, ref) => {
    const inputId = useUuid(id);
    testId = useTestId(testId)
    // if(minWidth === undefined && size) {
    //     minWidth = 30 + size*13
    // }

    return (
        <div className={cn(css.wrapper, {[css.hasIcon]: icon, [css.disabled]: disabled, [css.loading]: loading, [css.inline]: inline, [css.error]: error})}
             style={{width, minWidth, maxWidth}}>
            <input id={inputId} className={cn(css.text, inputClass)} disabled={disabled} {...inputProps} ref={ref} data-testid={testId}/>
            {icon ? <AioIcon name={error ? icons.faExclamationTriangle : icon}/> : null}
            <AioLabel htmlFor={inputId} className={labelClass} required={required}>{label}</AioLabel>
        </div>
    )
});

AioText.displayName = "AioText"

export default AioText;

